import {useTranslation} from 'react-i18next';
import Anchor from '../../../common/component/Anchor';
import Text from '../../../common/component/Text';

interface IProps {
  src?: string;
  textKey?: string;
  className?: string;
  onClick: () => void;
  index: number;
}

export default function HomeMenuV4({
  src,
  textKey,
  className,
  onClick,
  index,
}: IProps) {
  const {t} = useTranslation();
  return (
    <div
      className={cn({
        'flex-1': textKey,
        'mx-24': src,
        'text-right': index === 0,
      })}
    >
      <Anchor
        display={textKey ? 'inline-flex' : 'flex'}
        className={cn('flex-center h-36', className)}
        onClick={onClick}
      >
        {src && (
          <div className="relative px-4">
            <img src={src} alt="" />
          </div>
        )}
        {textKey && <Text className="mt-4">{t(textKey)}</Text>}
      </Anchor>
    </div>
  );
}
